import React, { Component, ReactNode } from 'react'
import styled from '@emotion/styled'
import {
    PRIMARY_FONT_CSS_VAR,
    PRIMARY_PAGE_TEXT_COLOR_VAR,
} from '../../context/CustomizationContextProvider'
import { getTypographyRoleStyle } from '../../style/typography'
import { scaledFontSize } from '../../style/scrollingLayout'

interface Props {
    children: ReactNode
    fallback?: ReactNode
}

interface State {
    hasError: boolean
    error: Error | null
}

const ErrorContainer = styled.div({
    padding: '8px 12px',
    ...getTypographyRoleStyle('statusText', {
        fontFamily: `var(${PRIMARY_FONT_CSS_VAR})`,
    }),
    fontSize: scaledFontSize(13),
    color: `var(${PRIMARY_PAGE_TEXT_COLOR_VAR})`,
    opacity: 0.7,
})

export class DiscountErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = { hasError: false, error: null }
    }

    static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error }
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.error('Discount calculation error:', error, errorInfo)
    }

    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback
            }
            return <ErrorContainer>Unable to calculate discount</ErrorContainer>
        }

        return this.props.children
    }
}
